/*
 * Models for the Topic Label list.  Just the headers for the sortableList.
 */

define([
  "backbone",
  "jquery",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, Messenger, SortableListModel) {
  Messenger.reqres.setHandler("topic:label:headers", function () {
    const Header = SortableListModel.headerModel;
    return new Backbone.Collection([
      new Header({
        headerName: $.t("languages.language"),
        modelAttribute: "languageId",
        customHtml: "<%- _thisObject.languageName %>",
        width: "20%",
      }),
      new Header({
        headerName: $.t("topic.label.label"),
        modelAttribute: "summary",
        editable: true,
      }),
    ]);
  });

  Messenger.reqres.setHandler("topic:label:headers:noedit", function () {
    const Header = SortableListModel.headerModel;
    return new Backbone.Collection([
      new Header({
        headerName: $.t("languages.language"),
        modelAttribute: "languageId",
        customHtml: "<%- _thisObject.languageName %>",
        width: "20%",
      }),
      new Header({
        headerName: $.t("topic.label.label"),
        modelAttribute: "summary",
        editable: false,
      }),
    ]);
  });
});
